module.exports = __webpack_public_path__ + "static/media/bgLoginMobile.2e4f8ef1.png";